export default __webpack_public_path__ + "static/media/16-KiwiSummer.96039148.jpeg";